// استيراد دوال React لإدارة الحالات والمراجع والتأثيرات الجانبية
import { useEffect, useRef, useState } from "react";
// استيراد مكون Form من React Bootstrap
import { Form } from "react-bootstrap";
// استيراد أيقونة الرفع من Font Awesome
import { faUpload } from "@fortawesome/free-solid-svg-icons";
// استيراد مكون عرض الأيقونات
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// استيراد كائن Axios المهيأ
import { Axios } from "../../../API/Axios";
// استيراد رابط API الخاص بالتصنيفات
import { Cat } from "../../../API/Api";
// استيراد مكون التحميل
import Loading from "../../../components/Loading/Loding";
// استيراد دوال التنقل والحصول على المعاملات من React Router
import { useNavigate, useParams } from "react-router-dom";
// استيراد سياق اللغة
import { useLanguage } from "../../../Context/LanguageContext";
// استيراد ملف الأنماط
import "../../../components/Dashboard/FormPage.css";

// المكون الرئيسي لتعديل التصنيف
export default function EditCategory ()
{
    // استيراد دالة الترجمة من سياق اللغة
    const { t } = useLanguage();
    // حالة لتخزين بيانات النموذج (العنوان والصورة)
    const [ formData, setFormData ] = useState( { title: "", image: "" } );
    // حالة لتخزين رابط الصورة الحالية
    const [ currentImage, setCurrentImage ] = useState( "" );
    // حالة لتعطيل الحقول حتى تحميل البيانات
    const [ disable, setDisable ] = useState( true );
    // حالة التحميل
    const [ loading, setLoading ] = useState( false );
    // دالة للتنقل بين الصفحات
    const nav = useNavigate();
    // استخراج معرف التصنيف من معاملات الرابط
    const { id } = useParams();
    // مرجع لحقل رفع الصورة
    const fileInput = useRef();

    // تأثير جانبي لجلب بيانات التصنيف عند تحميل المكون
    useEffect( () =>
    {
        // تفعيل حالة التحميل
        setLoading( true );
        // إرسال طلب GET لجلب بيانات التصنيف باستخدام المعرف
        Axios.get( `${ Cat }/${ id }` )
            .then( ( response ) =>
            {
                // إلغاء حالة التحميل
                setLoading( false );
                // تعبئة بيانات النموذج بالبيانات المسترجعة (الصورة تترك فارغة للتحديث)
                setFormData( { title: response.data.title, image: "" } );
                // تخزين رابط الصورة الحالية
                setCurrentImage( response.data.image );
            } )
            .then( () => setDisable( false ) ) // تمكين الحقول بعد تحميل البيانات
            .catch( () =>
            {
                // في حالة الخطأ، التوجيه إلى صفحة 404
                nav( "/dashboard/categories/page/404", { replace: true } );
            } );
    }, [ id ] ); // إعادة التشغيل عند تغيير المعرف

    // دالة معالجة تغيير المدخلات
    const handleChange = ( e ) =>
    {
        // استخراج اسم الحقل والقيمة والملفات من الحدث
        const { name, value, files } = e.target;
        // تحديث بيانات النموذج
        setFormData( {
            ...formData,
            // إذا كان الحقل هو الصورة ويوجد ملفات، استخدام الملف الأول، وإلا استخدام القيمة النصية
            [ name ]: name === "image" && files.length > 0 ? files[ 0 ] : value,
        } );
        // إذا تم اختيار صورة جديدة، عرض معاينة الصورة
        if ( name === "image" && files.length > 0 )
        {
            setCurrentImage( URL.createObjectURL( files[ 0 ] ) );
        }
    };

    // دالة غير متزامنة لمعالجة تقديم النموذج (تحديث التصنيف)
    async function handleSubmit ( e )
    {
        // منع إعادة تحميل الصفحة
        e.preventDefault();
        // تفعيل حالة التحميل
        setLoading( true );
        // إنشاء كائن FormData لإرسال الملفات والنصوص
        const form = new FormData();
        // إضافة العنوان إلى البيانات
        form.append( "title", formData.title );
        // إذا كانت هناك صورة جديدة، إضافتها إلى البيانات
        if ( formData.image ) form.append( "image", formData.image );

        try
        {
            // إرسال طلب POST لتحديث بيانات التصنيف مع FormData
            await Axios.post( `${ Cat }/edit/${ id }`, form );
            // إعادة توجيه المستخدم إلى صفحة قائمة التصنيفات بعد النجاح
            window.location.pathname = "/dashboard/categories";
        } catch ( error )
        {
            // طباعة الخطأ في وحدة التحكم
            console.log( error );
            // إلغاء حالة التحميل في حالة الخطأ
            setLoading( false );
        }
    }

    // عرض واجهة تعديل التصنيف
    return (
        <>
            {/* عرض مكون التحميل إذا كانت الحالة true */ }
            { loading && <Loading /> }
            {/* حاوية النموذج */ }
            <div className="form-page-wrap">
                {/* نموذج تعديل التصنيف */ }
                <Form className="form-page-card" onSubmit={ handleSubmit }>
                    {/* عنوان النموذج المترجم */ }
                    <h3 className="form-page-title">{ t( 'categories.editTitle' ) }</h3>

                    {/* حقل عنوان التصنيف */ }
                    <Form.Group className="mb-3" controlId="categoryTitle">
                        <Form.Label>{ t( 'categories.titleLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Control
                            value={ formData.title } // قيمة الحقل
                            onChange={ handleChange } // دالة التغيير
                            name="title" // اسم الحقل
                            type="text" // نوع الإدخال نص
                            placeholder={ t( 'categories.titlePlaceholder' ) } // النص الافتراضي المترجم
                            required // الحقل مطلوب
                            disabled={ disable } // تعطيل الحقل حتى تحميل البيانات
                        />
                    </Form.Group>

                    {/* حقل صورة التصنيف */ }
                    <Form.Group className="mb-3" controlId="categoryImage">
                        <Form.Label>{ t( 'categories.imageLabel' ) }</Form.Label> {/* تسمية الحقل */ }

                        {/* عرض الصورة الحالية إذا كانت موجودة */ }
                        { currentImage && (
                            <div className="server-image-chip mb-3">
                                <img src={ currentImage } alt="" /> {/* عرض الصورة */ }
                            </div>
                        ) }

                        {/* منطقة رفع الصورة */ }
                        <div
                            className={ `upload-dropzone ${ disable ? "" : "is-active" }` }
                            onClick={ () => !disable && fileInput.current.click() } // فتح نافذة اختيار الملف عند النقر
                        >
                            <span className="upload-dropzone-icon">
                                <FontAwesomeIcon icon={ faUpload } /> {/* أيقونة الرفع */ }
                            </span>
                            <p>{ t( 'products.uploadHere' ) }</p> {/* نص الرفع المترجم */ }
                        </div>
                        {/* حقل إدخال الملف المخفي */ }
                        <Form.Control
                            ref={ fileInput } // ربط المرجع
                            onChange={ handleChange } // دالة التغيير
                            name="image" // اسم الحقل
                            type="file" // نوع الإدخال ملف
                            disabled={ disable } // تعطيل الحقل حتى تحميل البيانات
                            className="d-none" // إخفاء الحقل
                        />
                    </Form.Group>

                    {/* زر الإرسال - يتم تعطيله حتى تحميل البيانات */ }
                    <button disabled={ disable } className="form-page-submit" type="submit">
                        { t( 'categories.save' ) } {/* نص الزر المترجم */ }
                    </button>
                </Form>
            </div>
        </>
    );
}